<cadastrar-empresa [tiposEmpresa]=tiposEmpresa titulo="Empresas Fornecedoras"></cadastrar-empresa>
